import {asString} from '../../helpers/converters/asString';

export function ensure<T>(fn: (o?: any) => o is T, o?: any, msg?: string): asserts o is T {
    if (!fn(o)) {
        throw new TypeError(msg ?? `TypeScript Error: ${asString(fn)} requirements have been not met for ${asString(o)}`);
    }
}
